module.exports = __webpack_public_path__ + "static/media/ve.05e44e4a.webp";